<template>
<div class="bg" style="background-color: #f7f9fc;">
    <div class="container">
        <div class="row" style="text-align: left;">
            <div class="pl-3">
                <div style="margin-bottom: 20px;">
                    <span style="font-weight: bold; color: white; font-size: 20px;"> <img src="@/assets/protelLogo.png" style="width: 130px;" alt=""></span>
                </div>
            </div>
        </div>
        <div class="row">
            <p class="col-xl-12 col-md-12 col-sm-12 pl-3" style="color: grey; text-align: left; font-size: 16px !important;"> © {{new Date().getFullYear()}} Protel. {{ $t("footer") }}</p>
        </div>
    </div>
</div> 
</template>

<script>

export default {
  name: 'Footer',
  data(){
      return{
        }
  },
  async mounted(){
   
  },

  methods : {
     
  },

  components: {

  },
  props: {

  },
      
 computed: {
  },
}

</script>

<style scoped>
.bg{
    padding-top: 70px;
    padding-bottom: 70px;
}
.navItem{
    color: #F7F8FC;
    font-size: 16px;
    font-weight: 600;
    padding-right: 10px;
    padding-left: 10px;
}
.navItem:hover{
    color: #F5AD0B;
}
.ddItem{
    text-align: right;  
}

</style>
